namespace $.$$ {

	$mol_style_define( $rise_devtools_selector, {
		position: 'fixed',
		left: 0,
		top: 0,
		width: 0,
		height: 0,
		pointerEvents: 'none',
		zIndex: 2147483647,
	} )
}
